class CartCrossSell extends HTMLElement {
  constructor() {
    super();
    this.list = this.querySelector('.cart-drawer__cross-sell-list');
    this.refresh();
  }

  async refresh() {
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      if (!cart.items.length) {
        this.hidden = true;
        return;
      }

      const cartProductIds = new Set(cart.items.map((item) => item.product_id));
      const seedId = cart.items[cart.items.length - 1].product_id;
      const recRes = await fetch(
        `/recommendations/products.json?product_id=${seedId}&limit=6&intent=related`
      );
      if (!recRes.ok) throw new Error('recommendations request failed');
      const { products } = await recRes.json();
      const picks = (products || []).filter((product) => !cartProductIds.has(product.id)).slice(0, 3);

      if (!picks.length) {
        this.hidden = true;
        return;
      }

      this.render(picks);
      this.hidden = false;
    } catch (error) {
      this.hidden = true;
    }
  }

  render(products) {
    this.list.innerHTML = products
      .map((product) => {
        const variant = product.variants && product.variants[0];
        const image = product.featured_image || (product.images && product.images[0]) || '';
        const price = variant ? this.formatMoney(variant.price) : '';
        const available = variant && variant.available;
        return `
          <li class="cart-drawer__cross-sell-item">
            <a href="${product.url}" class="cart-drawer__cross-sell-media">
              ${image ? `<img src="${image}" alt="${this.escapeHtml(product.title)}" loading="lazy" width="56" height="56">` : ''}
            </a>
            <div class="cart-drawer__cross-sell-info">
              <a href="${product.url}" class="cart-drawer__cross-sell-title">${this.escapeHtml(product.title)}</a>
              <span class="cart-drawer__cross-sell-price">${price}</span>
            </div>
            <button
              type="button"
              class="button button--tertiary cart-drawer__cross-sell-add"
              data-variant-id="${variant ? variant.id : ''}"
              ${!available ? 'disabled' : ''}
            >
              Add
            </button>
          </li>
        `;
      })
      .join('');

    this.list.querySelectorAll('[data-variant-id]').forEach((button) => {
      if (!button.getAttribute('data-variant-id')) return;
      button.addEventListener('click', () => this.addToCart(button));
    });
  }

  async addToCart(button) {
    const variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;
    button.setAttribute('disabled', 'true');
    const originalLabel = button.textContent;
    try {
      const sectionsToRequest = ['cart-icon-bubble'];
      if (document.getElementById('CartDrawer')) sectionsToRequest.push('cart-drawer');

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: sectionsToRequest,
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'add to cart failed');
      this.applySections(data.sections);
      button.textContent = 'Added ✓';
      setTimeout(() => {
        button.textContent = originalLabel;
        button.removeAttribute('disabled');
      }, 1800);
    } catch (error) {
      button.textContent = originalLabel;
      button.removeAttribute('disabled');
    }
  }

  applySections(sections) {
    if (!sections) return;

    if (sections['cart-drawer']) {
      const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const newContent = doc.querySelector('#CartDrawer');
      const current = document.getElementById('CartDrawer');
      if (newContent && current) current.innerHTML = newContent.innerHTML;

      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        drawer.classList.remove('is-empty');
        if (!drawer.classList.contains('active')) {
          drawer.classList.add('animate', 'active');
        }
      }
    }

    if (sections['cart-icon-bubble']) {
      const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      const newBubble = doc.querySelector('.shopify-section');
      const currentBubble = document.getElementById('cart-icon-bubble');
      if (newBubble && currentBubble) currentBubble.innerHTML = newBubble.innerHTML;
    }
  }

  formatMoney(cents) {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AED';
    try {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency });
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  }

  escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }
}

if (!customElements.get('cart-cross-sell')) {
  customElements.define('cart-cross-sell', CartCrossSell);
}
